import MenuData from 'models/MenuData';
import biobarApi from './base/biobarApi';
import { getCompanyId } from 'utils/identifier';
import { getRoute } from 'utils/impersonate';

export default async function getMenuData(identifier : string, preferredLanguage : string) : Promise<MenuData> {
  const companyId = getCompanyId();

  const { data } = await biobarApi.get<MenuData>(
    `${getRoute()}/menu`+
    `?preferredLanguage=${preferredLanguage}` +
    `&identifier=${identifier}` +
    `${!companyId ? '' : `&companyId=${companyId}`}`
  );

  return data;
}
